import React from 'react'
import { Button, Glyphicon } from 'react-bootstrap'

const WeekPicker = (props) => {
  return (
    <div id="WeekPicker">
      <h4 style={{display:"inline-block"}}>
        <Button onClick={props.setWeekToPrevious}>
          <Glyphicon glyph="chevron-left" />
        </Button>

        <span style={{margin: '0 10px'}}>
          Week of {props.firstDay}
        </span>

        <Button onClick={props.setWeekToNext}>
          <Glyphicon glyph="chevron-right" />
        </Button>
      </h4>
    </div>
  )
}

export default WeekPicker



// WEBPACK FOOTER //
// ./src/routes/workload/components/WeekPicker.js